import { render } from "./loveQyDetail.vue?vue&type=template&id=b5fdcef6"
import script from "./loveQyDetail.vue?vue&type=script&lang=js"
export * from "./loveQyDetail.vue?vue&type=script&lang=js"

import "./loveQyDetail.vue?vue&type=style&index=0&id=b5fdcef6&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__